import { useNavigate } from 'react-router-dom';
import { OurBlogs } from '../../../../Data/Blogs/OurBlogs';
import '../CSS_File/MainBlogPage.css';

function BlogAlsoRead() {
    // const [data, showData] = useState(ourBlogs);
    const navigate = useNavigate();
    let randomArrayNumOne = Math.floor(Math.random() * OurBlogs.length);
    let randomArrayNumTwo = Math.floor(Math.random() * OurBlogs.length);
    let randomArrayNumThree = Math.floor(Math.random() * OurBlogs.length);
    return (
        <>
            <section className="blogAlsoReadSectionStartHere">
                <div className="container">
                    <div className="row justify-content-evenly">
                        <div className="col-md-12 blogAlsoReadHeading">
                            <h2>also read</h2>
                        </div>
                        <div className="col-lg-4 col-md-5 col-xl-4 blogAlsoReadCard my-3">
                            <div className="blog-also-read-first-inner-div">
                                <img src={OurBlogs[randomArrayNumOne].blogImage} alt={OurBlogs[randomArrayNumOne].altTag} className="img-fluid card-img-top cardImage" />
                                <div className="card-body blogAlsoReadCardBody" id='blogAlsoReadCardBody'>
                                    <h5>{OurBlogs[randomArrayNumOne].title}</h5>
                                    <p>{OurBlogs[randomArrayNumOne].description.slice(0, 125)}...</p>
                                    <button className="blogAlsoReadCardButton" onClick={() => navigate(OurBlogs[randomArrayNumOne].newPage)}>Read More</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5 col-xl-4 blogAlsoReadCard my-3">
                            <div className="blog-also-read-first-inner-div">
                                <img src={OurBlogs[randomArrayNumTwo].blogImage} alt={OurBlogs[randomArrayNumTwo].altTag} className="img-fluid card-img-top cardImage" />
                                <div className="card-body blogAlsoReadCardBody" id='blogAlsoReadCardBody'>
                                    <h5>{OurBlogs[randomArrayNumTwo].title}</h5>
                                    <p>{OurBlogs[randomArrayNumTwo].description.slice(0, 125)}...</p>
                                    <button className="blogAlsoReadCardButton" onClick={() => navigate(OurBlogs[randomArrayNumTwo].newPage)}>Read More</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5 col-xl-4 blogAlsoReadCard my-3">
                            <div className="blog-also-read-first-inner-div">
                                <img src={OurBlogs[randomArrayNumThree].blogImage} alt={OurBlogs[randomArrayNumThree].altTag} className="img-fluid card-img-top cardImage" />
                                <div className="card-body blogAlsoReadCardBody" id='blogAlsoReadCardBody'>
                                    <h5>{OurBlogs[randomArrayNumThree].title}</h5>
                                    <p>{OurBlogs[randomArrayNumThree].description.slice(0, 125)}...</p>
                                    <button className="blogAlsoReadCardButton" onClick={() => navigate(OurBlogs[randomArrayNumThree].newPage)}>Read More</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BlogAlsoRead